/* Sport collection pages — interactivity only. FAQ accordion behaviour is already
   handled globally by cl-collection.js against .cl-faq / .cl-faq__q, so this file
   does not duplicate it. */
(function () {
  "use strict";

  function initSweatCalc() {
    var root = document.querySelector("[data-sweat-calc]");
    if (!root) return;
    var conditions = JSON.parse(root.getAttribute("data-conditions"));
    var durationHours = parseFloat(root.getAttribute("data-duration")) || 3;
    var buttons = document.querySelectorAll("[data-condition-btn]");
    var out = {
      rate: root.querySelector("[data-out-rate]"),
      conc: root.querySelector("[data-out-conc]"),
      sweatBar: root.querySelector("[data-out-sweatbar]"),
      concBar: root.querySelector("[data-out-concbar]"),
      fluid: root.querySelector("[data-out-fluid]"),
      bottles: root.querySelector("[data-out-bottles]"),
      bottleLabel: root.querySelector("[data-out-bottlelabel]"),
      total: root.querySelector("[data-out-total]"),
      serves: root.querySelector("[data-out-serves]"),
      perHour: root.querySelector("[data-out-perhour]"),
    };

    function render(key) {
      var c = conditions.find(function (x) { return x.key === key; });
      if (!c) return;
      var fluid = c.rate * durationHours;
      var total = Math.round(fluid * c.conc);
      var serves = total / 1000;
      var bottleCount = Math.ceil(fluid / 0.75);

      buttons.forEach(function (b) {
        b.setAttribute("aria-pressed", b.getAttribute("data-condition-btn") === key ? "true" : "false");
      });

      out.rate.textContent = c.rate.toFixed(1) + " litres per hour";
      out.conc.textContent = c.conc.toLocaleString() + " mg per litre";
      out.sweatBar.style.width = Math.round((c.rate / 2) * 100) + "%";
      out.concBar.style.width = Math.round((c.conc / 1500) * 100) + "%";
      out.fluid.textContent = fluid.toFixed(1) + " litres";

      out.bottles.innerHTML = "";
      for (var i = 0; i < bottleCount; i++) {
        var remaining = fluid - i * 0.75;
        var fill = Math.round(Math.min(1, remaining / 0.75) * 100) + "%";
        var el = document.createElement("div");
        el.className = "cl-sweat-bottle";
        el.title = "750 ml bidon";
        el.style.background = "linear-gradient(to top, var(--cl-accent) " + fill + ", #fff " + fill + ")";
        out.bottles.appendChild(el);
      }
      out.bottleLabel.textContent = bottleCount + " × 750 ml bidons";
      out.total.textContent = total.toLocaleString();
      out.serves.textContent = serves.toFixed(1) + " serves";
      out.perHour.textContent = Math.round(total / durationHours).toLocaleString() + " mg per hour";
    }

    buttons.forEach(function (b) {
      b.addEventListener("click", function () { render(b.getAttribute("data-condition-btn")); });
    });
    render(root.getAttribute("data-default-condition") || conditions[0].key);
  }

  function initTagline() {
    var el = document.querySelector("[data-tagline]");
    if (!el) return;
    var words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map(function (w) { return '<span class="word">' + w + "</span>"; }).join(" ");
    if (!("IntersectionObserver" in window)) {
      el.querySelectorAll(".word").forEach(function (w) { w.classList.add("is-active"); });
      return;
    }
    var spans = el.querySelectorAll(".word");
    var io = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        spans.forEach(function (w, i) { setTimeout(function () { w.classList.add("is-active"); }, i * 60); });
        observer.disconnect();
      });
    }, { threshold: 0.6 });
    io.observe(el);
  }

  function initStickyBar() {
    var bar = document.querySelector("[data-sticky-cta]");
    var hero = document.querySelector("[data-hero-sentinel]");
    if (!bar || !hero || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { bar.classList.toggle("is-visible", !entry.isIntersecting); });
    }, { rootMargin: "-64px 0px 0px 0px" });
    io.observe(hero);
  }

  function initQuizTeaser() {
    var root = document.querySelector("[data-quiz-teaser]");
    if (!root) return;
    var state = {};
    var steps = root.querySelectorAll("[data-quiz-step]");
    var result = root.querySelector("[data-quiz-result]");

    function showStep(index) { steps.forEach(function (s, i) { s.hidden = i !== index; }); }

    root.querySelectorAll("[data-quiz-option]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        state[btn.getAttribute("data-quiz-group")] = btn.getAttribute("data-quiz-value");
        var currentIndex = Array.prototype.indexOf.call(steps, btn.closest("[data-quiz-step]"));
        if (currentIndex < steps.length - 1) { showStep(currentIndex + 1); } else { renderResult(); }
      });
    });

    /* Brand picks are read from data attributes so this teaser works for any hero-brand
       pair, not just LMNT/SaltStick — data-a-* is the "salty + long/frequent" pick,
       data-b-* the default. data-b-pocket-* optionally overrides the name/reason shown
       when the visitor prefers a dry, pocket-carried format; pages without a
       capsule-style secondary brand can omit it and the b-pick is used for both. */
    function renderResult() {
      var salty = state.sweat === "salty";
      var long = state.duration === "long";
      var pocket = state.carry === "pocket";
      var pick;
      if (salty && long) {
        pick = { name: root.getAttribute("data-a-name"), reason: root.getAttribute("data-a-reason"), href: root.getAttribute("data-a-url") };
      } else if (pocket) {
        pick = {
          name: root.getAttribute("data-b-pocket-name") || root.getAttribute("data-b-name"),
          reason: root.getAttribute("data-b-pocket-reason") || root.getAttribute("data-b-reason"),
          href: root.getAttribute("data-b-url"),
        };
      } else {
        pick = { name: root.getAttribute("data-b-name"), reason: root.getAttribute("data-b-reason"), href: root.getAttribute("data-b-url") };
      }
      steps.forEach(function (s) { s.hidden = true; });
      result.hidden = false;
      result.querySelector("[data-quiz-pick-name]").textContent = pick.name;
      result.querySelector("[data-quiz-pick-reason]").textContent = pick.reason;
      result.querySelector("[data-quiz-pick-link]").href = pick.href;
    }

    root.querySelectorAll("[data-quiz-restart]").forEach(function (btn) {
      btn.addEventListener("click", function () { state = {}; result.hidden = true; showStep(0); });
    });
  }

  /* "Also stocked" shows 5 products; the rest stay hidden (via the
     .cl-product-tile--extra class) until "See all" is clicked, or until the hero /
     sticky "Shop" links (which point at #cl-shop) are clicked. Uses a single delegated
     document click listener for BOTH triggers (rather than binding to the toggle button
     directly at load time) so it keeps working even if the button/grid get reflowed or
     re-inserted by another script after DOMContentLoaded. */
  function initShopReveal() {
    var section = document.getElementById("cl-shop");
    if (!section) return;

    function reveal() {
      var grid = section.querySelector("[data-see-all-grid]");
      var toggle = section.querySelector("[data-see-all-toggle]");
      if (grid) grid.classList.add("is-expanded");
      if (toggle) toggle.hidden = true;
    }

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-see-all-toggle]")) {
        reveal();
        return;
      }
      var link = e.target.closest('a[href$="#cl-shop"]');
      if (!link) return;
      e.preventDefault();
      reveal();
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  /* Subscribes the entered address to Klaviyo's "Email List" (single opt-in, so no
     confirmation-email step) via Klaviyo's public Create Client Subscription endpoint —
     the company_id (public API key) is safe to ship client-side; no private key here. */
  var KLAVIYO_COMPANY_ID = "TDkbEH";
  var KLAVIYO_EMAIL_LIST_ID = "VpK52F";

  function initEmailCapture() {
    var form = document.querySelector("[data-email-capture]");
    if (!form) return;
    var input = form.querySelector("input[type=email]");
    var msg = form.querySelector("[data-email-msg]");
    var button = form.querySelector("button");

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = input.value.trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (!valid) {
        msg.textContent = "Enter a valid email address.";
        msg.hidden = false;
        msg.setAttribute("data-error", "");
        input.setAttribute("aria-invalid", "true");
        return;
      }
      input.setAttribute("aria-invalid", "false");
      msg.removeAttribute("data-error");
      button.disabled = true;

      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_COMPANY_ID, {
        method: "POST",
        headers: { "Content-Type": "application/json", revision: "2024-10-15" },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: { data: { type: "profile", attributes: { email: email } } },
            },
            relationships: {
              list: { data: { type: "list", id: KLAVIYO_EMAIL_LIST_ID } },
            },
          },
        }),
      })
        .then(function (res) {
          if (!res.ok && res.status !== 202) throw new Error("Klaviyo subscribe failed");
          msg.textContent = "Thanks — you're on the list, and your result is above.";
          msg.hidden = false;
        })
        .catch(function () {
          msg.textContent = "Something went wrong — please try again.";
          msg.hidden = false;
          msg.setAttribute("data-error", "");
          button.disabled = false;
        });
    });
  }

  /* Each init runs independently — a failure in one (e.g. a malformed data-conditions
     JSON on a future page) must not stop the others from wiring up. */
  document.addEventListener("DOMContentLoaded", function () {
    [initSweatCalc, initTagline, initStickyBar, initShopReveal, initQuizTeaser, initEmailCapture].forEach(function (fn) {
      try {
        fn();
      } catch (err) {
        if (window.console && console.error) console.error("cl-sport.js:", fn.name, err);
      }
    });
  });
})();
